import { useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { AddCustomImage } from 'services/addBox'
import { RootState } from 'store/redux'
import { resetImage } from 'store/redux/image'
import { reset, toggleMoneyPool } from 'store/redux/moneyPoolBox'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSetCustomImage(statege: number | undefined) {
    // read at render: `reset()` below clears the store before the event fires
    const goal = useSelector((state: RootState) => state.MoneyPoolBoxAdd?.goal)
    const startedAsTransfer = useSelector(
        (state: RootState) => state.MoneyPoolBoxAdd?.isTransfer
    )
    const isTransfer = statege !== 1
    const dispatch = useDispatch()
    // see useSetAddFirstBox: the fund exists, its forms are spent
    const finishFlow = useFinishFlow(FLOWS.createFund)
    const { mutate, isLoading } = useMutation({
        mutationFn: (payload: { file: File; id: number }) => {
            return AddCustomImage(payload)
        },
        onSuccess: (res) => {
            dispatch(
                toggleMoneyPool({
                    moneyPool: res.results.id,
                    poolShip: res.results.poolship.id,
                })
            )
            if (statege === 1) {
                dispatch(reset())
                dispatch(resetImage())
                posthog.capture('fund_created', {
                    creation_path: 'custom_image',
                    fund_id: (res as any)?.results?.id,
                    goal: goal || undefined,
                    is_transfer: false,
                })
                finishFlow('/funds')
                toast.success('صندوق با موفقیت ساخته شد')
            } else {
                // see useSetAddFirstBox
                posthog.capture('fund_transfer_base_created', {
                    creation_path: 'custom_image',
                    fund_id: (res as any)?.results?.id,
                    transfer_origin: startedAsTransfer ? 'start' : 'last_modal',
                })
                toast.success(
                    'صندوق شما با اطلاعات اولیه ساخته شد . اکنون سوابق مدیر را وارد کنید'
                )
                finishFlow('/add-box/manager-records')
            }
        },
        onError: () => {
            posthog.capture('fund_create_failed', {
                creation_path: 'custom_image',
                goal: goal || undefined,
                is_transfer: isTransfer,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { CustomImageMutate: mutate, isLoadingImage: isLoading }
}
